module.exports = __webpack_public_path__ + "static/hero-bg-388e3f55f012f3a3ba6f79f067decd5c.png";